// extracted by mini-css-extract-plugin
export default {"buttons":"MessagePage_buttons__IIGJS","button":"MessagePage_button__xMuHl"};